import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  setCartQuantity,
} from "../../../redux/actions/cart_actions";
import IndexHeader from "components/Headers/IndexHeader.js";
import { HOST_URL } from "../../../utils/misc.js";
import CartBlock from "../../../components/CartBlock/CartBlock";
import { Button } from "reactstrap";
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import NProgress from 'nprogress';

const Cart = (props) => {  

  useEffect(() => {
    NProgress.start()
    // Scroll To Top
    // window.scrollTo(0, 0)
    setTimeout(() => {
      NProgress.done()
    }, 800)
  }, [props.cart.cartQuantity]);

  const handleNavigation = () => {
    props.history.push("/confirm")
  }
  
  const getSteps = () => {
    return ['Xác nhận giỏ hàng', 'Xác nhận đơn hàng', 'Xác nhận thông tin', 'Tiến hành đặt hàng'];
  }

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  
  const renderCart = () => {
    if(props.cart.carts && props.cart.carts.length > 0) {      
      return(
        <>
        <div className="container-fluid">
          <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
          </Stepper>
        </div>
          <div className="container" style={{ marginBottom: "1%" }}>
            <div style={{ backgroundColor: 'rgb(247, 247, 247)', padding:"1%", borderRadius:10 }}>
              <h3 className="text-center"><b>Danh sách sản phẩm</b></h3>
              <CartBlock
                type="cart"
                title="cart"
              />
            </div>
            <div className="confirmInfo mt-2">
              <Button className="btn btn-md btn-default btn-round o" onClick={handleNavigation}>Xác nhận thông tin <i className="fa fa-arrow-right" aria-hidden="true"></i></Button>
            </div>
          </div>
        </>
      )
    }
    return(
      <>
        <div className="text-center" style={{ marginBottom: "2%" }}>
          <h1><RemoveShoppingCartIcon style={{ fontSize: 50 }} /></h1>
          <h3 className="text-center"><b>Chưa có sản phẩm trong giỏ hàng</b></h3>
        </div>
      </>
    )
  }
  
  return (
    <>
    <IndexHeader title="Giỏ Hàng" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_cartpage} minHeight="500" />
    <div className="container-fluid p-0">
      {renderCart()}
    </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Cart);